// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gj7_F5sSamVOlsoqI_Zv {
  --progress-item-border: 1.5px;
  position: relative;
  height: 12px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .gj7_F5sSamVOlsoqI_Zv {
    --progress-item-border: 1px;
    height: 8px;
  }
}
[data-variant='card'].gj7_F5sSamVOlsoqI_Zv {
  background: #0a1a0f;
  border-style: solid;
  border-color: #243827;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY {
  background: linear-gradient(90deg, var(--segment-gradient-start), var(--segment-gradient-end));
  border-style: solid;
  height: 100%;
  position: relative;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
  content: '';
  width: 1.5px;
  height: 28px;
  position: absolute;
  right: 0;
  bottom: 0;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
    height: 18px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
    width: 1px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
    width: 1px;
  }
}
}
}
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true'][data-is-unlocked='true']:after {
  background: #3CFF00;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true'][data-is-unlocked='false']:after {
  background: #6D6D6D;
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-unlocked='true'] {
  border-color: #00570D;
  box-shadow: 0 0 6px 0 rgba(60, 255, 0, 0.2);
}
[data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-unlocked='false'] {
  border-color: #243827;
  box-shadow: 0 0 30px 0 rgba(60, 255, 0, 0.2);
}
[data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
  --tooltip-width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  height: 21px;
  width: var(--tooltip-width);
  position: absolute;
  top: -40px;
  right: calc(-1 * var(--tooltip-width) / 2);
  transform: translateX(var(--tooltip-clamp-offset, 0px));
  letter-spacing: 0.375px;
  z-index: 1;
}
[data-variant='card'] .TWF1cYwFuFtufOYp_nbr[data-status='unlocked'] {
  background: linear-gradient(270deg, rgba(44, 108, 2, 0) 0%, #2C6C02 50%, rgba(44, 108, 2, 0) 100%);
}
[data-variant='card'] .TWF1cYwFuFtufOYp_nbr[data-status='locked'] {
  background: linear-gradient(270deg, rgba(88, 88, 88, 0) 0%, #585858 50%, rgba(88, 88, 88, 0) 100%);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
    --tooltip-width: 43px;
    height: 14px;
    font-size: 12px;
    top: -28px;
  }
}
[data-variant='card'] .iq6Er0V95LO0JTnALePa {
  font-size: 12px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='card'] .iq6Er0V95LO0JTnALePa {
    font-size: 8px;
  }
}
/* More than one camapaign */
[data-has-many='true'] [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
  height: 21px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] [data-variant='card'] .n2gSnWPbcLnX8vJNosTY[data-is-current='true']:after {
    height: 15px;
    width: 1px;
  }
}
[data-has-many='true'] [data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
  top: -34px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-has-many='true'] [data-variant='card'] .TWF1cYwFuFtufOYp_nbr {
    top: -25px;
  }
}
[data-variant='winnings-tab'].gj7_F5sSamVOlsoqI_Zv {
  border: var(--progress-item-border) solid #4F4403;
  border-radius: 7.5px;
  position: relative;
  width: var(--progress-item-width, 102px);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='winnings-tab'].gj7_F5sSamVOlsoqI_Zv {
    width: var(--progress-item-width, 68px);
  }
}
[data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY {
  background: #FFDF1A;
  box-shadow: 0 0 6px 0 rgba(255, 223, 26, 0.5);
  border-radius: 7.5px 0 0 7.5px;
  border: var(--progress-item-border) solid #4F4403;
  height: 12px;
  position: absolute;
  top: calc(-1 * var(--progress-item-border));
  left: calc(-1 * var(--progress-item-border));
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY {
    height: 8px;
  }
}
[data-variant='winnings-tab'] .n2gSnWPbcLnX8vJNosTY[data-percent='100'] {
  border-radius: 7.5px;
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/variants/rebate/RebateProgressItem/RebateProgressItem.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE;IACE,2BAA2B;IAC3B,WAAW;EACb;AACF;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,8FAA8F;EAC9F,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,UAAU;EACZ;AACF;AAAA;AAAA;AAAA;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,uDAAuD;EACvD,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,kGAAkG;AACpG;AACA;EACE,kGAAkG;AACpG;AACA;EACE;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA,4BAA4B;AAC5B;EACE,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,iDAAiD;EACjD,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE;IACE,uCAAuC;EACzC;AACF;AACA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,8BAA8B;EAC9B,iDAAiD;EACjD,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,4CAA4C;AAC9C;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,oBAAoB;AACtB","sourcesContent":[".progressItemContainer {\n  --progress-item-border: 1.5px;\n  position: relative;\n  height: 12px;\n}\n@media (--campaign-mobile) {\n  .progressItemContainer {\n    --progress-item-border: 1px;\n    height: 8px;\n  }\n}\n[data-variant='card'].progressItemContainer {\n  background: #0a1a0f;\n  border-style: solid;\n  border-color: #243827;\n}\n[data-variant='card'] .progressItemFill {\n  background: linear-gradient(90deg, var(--segment-gradient-start), var(--segment-gradient-end));\n  border-style: solid;\n  height: 100%;\n  position: relative;\n}\n[data-variant='card'] .progressItemFill[data-is-current='true']:after {\n  content: '';\n  width: 1.5px;\n  height: 28px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n@media (--campaign-mobile) {\n  [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n    height: 18px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n    width: 1px;\n  }\n}\n[data-variant='card'] .progressItemFill[data-is-current='true'][data-is-unlocked='true']:after {\n  background: #3CFF00;\n}\n[data-variant='card'] .progressItemFill[data-is-current='true'][data-is-unlocked='false']:after {\n  background: #6D6D6D;\n}\n[data-variant='card'] .progressItemFill[data-is-unlocked='true'] {\n  border-color: #00570D;\n  box-shadow: 0 0 6px 0 rgba(60, 255, 0, 0.2);\n}\n[data-variant='card'] .progressItemFill[data-is-unlocked='false'] {\n  border-color: #243827;\n  box-shadow: 0 0 30px 0 rgba(60, 255, 0, 0.2);\n}\n[data-variant='card'] .totalWinTooltip {\n  --tooltip-width: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  height: 21px;\n  width: var(--tooltip-width);\n  position: absolute;\n  top: -40px;\n  right: calc(-1 * var(--tooltip-width) / 2);\n  transform: translateX(var(--tooltip-clamp-offset, 0px));\n  letter-spacing: 0.375px;\n  z-index: 1;\n}\n[data-variant='card'] .totalWinTooltip[data-status='unlocked'] {\n  background: linear-gradient(270deg, rgba(44, 108, 2, 0) 0%, #2C6C02 50%, rgba(44, 108, 2, 0) 100%);\n}\n[data-variant='card'] .totalWinTooltip[data-status='locked'] {\n  background: linear-gradient(270deg, rgba(88, 88, 88, 0) 0%, #585858 50%, rgba(88, 88, 88, 0) 100%);\n}\n@media (--campaign-mobile) {\n  [data-variant='card'] .totalWinTooltip {\n    --tooltip-width: 43px;\n    height: 14px;\n    font-size: 12px;\n    top: -28px;\n  }\n}\n[data-variant='card'] .totalWinTooltipCurrency {\n  font-size: 12px;\n}\n@media (--campaign-mobile) {\n  [data-variant='card'] .totalWinTooltipCurrency {\n    font-size: 8px;\n  }\n}\n/* More than one camapaign */\n[data-has-many='true'] [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n  height: 21px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] [data-variant='card'] .progressItemFill[data-is-current='true']:after {\n    height: 15px;\n    width: 1px;\n  }\n}\n[data-has-many='true'] [data-variant='card'] .totalWinTooltip {\n  top: -34px;\n}\n@media (--campaign-mobile) {\n  [data-has-many='true'] [data-variant='card'] .totalWinTooltip {\n    top: -25px;\n  }\n}\n[data-variant='winnings-tab'].progressItemContainer {\n  border: var(--progress-item-border) solid #4F4403;\n  border-radius: 7.5px;\n  position: relative;\n  width: var(--progress-item-width, 102px);\n}\n@media (--campaign-mobile) {\n  [data-variant='winnings-tab'].progressItemContainer {\n    width: var(--progress-item-width, 68px);\n  }\n}\n[data-variant='winnings-tab'] .progressItemFill {\n  background: #FFDF1A;\n  box-shadow: 0 0 6px 0 rgba(255, 223, 26, 0.5);\n  border-radius: 7.5px 0 0 7.5px;\n  border: var(--progress-item-border) solid #4F4403;\n  height: 12px;\n  position: absolute;\n  top: calc(-1 * var(--progress-item-border));\n  left: calc(-1 * var(--progress-item-border));\n}\n@media (--campaign-mobile) {\n  [data-variant='winnings-tab'] .progressItemFill {\n    height: 8px;\n  }\n}\n[data-variant='winnings-tab'] .progressItemFill[data-percent='100'] {\n  border-radius: 7.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressItemContainer": `gj7_F5sSamVOlsoqI_Zv`,
	"progressItemFill": `n2gSnWPbcLnX8vJNosTY`,
	"totalWinTooltip": `TWF1cYwFuFtufOYp_nbr`,
	"totalWinTooltipCurrency": `iq6Er0V95LO0JTnALePa`
};
export default ___CSS_LOADER_EXPORT___;
